export default __webpack_public_path__ + "static/media/icon-social-disable.786363db.svg";